// @flow

import { isCD, isCrawling } from "./envDetection";

const localStorageExport = async (key, value) => {
    let item;
    if (isCD || isCrawling) {
        item = "disabled-local-storage";
    } else {
        const localStorage = await import("local-storage");
        if (value === undefined) {
            item = localStorage(key);
        } else {
            item = localStorage(key, value);
        }
    }

    return item;
};

export default localStorageExport;



// WEBPACK FOOTER //
// ./src/rest/utils/local-storage.js